import React from 'react'

import InlineSVG from 'svg-inline-react'

import svgJson from './svgLetters.json'
import capitularStyles from './capitular.module.scss'

// const Capitular = ({ text }) => {
class Capitular extends React.Component {
  constructor(props) {
    super(props)
    this.set = this.set.bind(this)
    this.state = {
      svgElement: null,
    }
  }

  set() {
    setInterval(() => {
      const svg = svgJson[Math.round(Math.random() * (svgJson.length - 1))].svg
      this.setState({ svg })

      // const firstLetter = text.substring(0, 1)
      const svgElement =
        svgJson[Math.round(Math.random() * (svgJson.length - 1))]
      this.setState({ svgElement })
    }, 1500)
  }

  render() {
    const { text } = this.props

    const firstLetter = text.substring(0, 1)
    const svgElement = svgJson.find(el => el.char === firstLetter)

    if (svgElement) {
      // if (this.state.svgElement) {
      // return (
      //   <InlineSVG
      //     className={capitularStyles.svg}
      //     src={this.state.svgElement.svg}
      //   />
      // )
      return <InlineSVG className={capitularStyles.svg} src={svgElement.svg} />
    } else {
      return null
    }
  }

  componentDidMount() {
    // this.set()
  }
}

export default Capitular
